import moment from 'moment'

export default {
  computed: {
    $csrfToken () {

        const token = document.head.querySelector('meta[name="csrf-token"]')
        if (token) {
          return token.content
        }
        throw Error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
    },
    $errors () {
      return window.errors || {}
    },
  },
  methods: {
    $hasAnyErrors () {
      if (!window.errors) return false
      return Object.keys(window.errors).length > 0
    },
    $hasError (property) {
      if (!window.errors) return null
      return !!window.errors[property] ? true : null
    },
    $errorMessage (property) {
      if (!this.$hasError(property)) return ''
      return window.errors[property][0]
    },
    $old (property, fallback = null) {
      return window.oldData.hasOwnProperty(property) ? window.oldData[property] : fallback
    },

    async $checkTokenAge () {
      const token = document.head.querySelector('meta[name="csrf-token"]')
      if (token && token.hasAttribute('age')) {
        const ageDifference = moment().diff(moment(token.getAttribute('age')), 'hours')
        if (ageDifference > 3 && await this.$confirm({
          title: 'Sessie verouderd',
          messages: [
            'Uw sessie is verouderd. Wilt u de pagina verversen?'
          ],
          okLabel: 'Verversen',
          cancelLabel: 'Negeren'
        })) {
          location.reload()
          return false
        }
      }
      return true
    },
  },
}
